<template>
  <div
    v-if="progressBar"
    class="bg-white p-5 rounded-md border border-grey-300 overflow-hidden shadow mt-4"
  >
    <div class="w-full bg-white">
      <p class="text-sm font-semibold mb-2 font-dark" id="progress_percentage">
        {{ progressBar }}{{ $t('frontend_groovemember_left_panel_progress_bar_heading') }}
      </p>
      <div class="bg-white">
        <div class="w-full bg-white">
          <div class="bg-grey-200 rounded-md">
            <div
              id="progress_bar_width"
              class="bg-green-light rounded-md w-0 h-3"
              :style="{ width: progressBar + '%' }"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ProgressBar",
  props: ["progressBar"],
};
</script>